import { radius } from "../../website-kit";
import Navigation from "@/components/samples/Navigation";
import DarkModeToggle from "@/components/samples/DarkModeToggle";
import withStagingOnly, {
  getServerSideProps,
} from "@/components/samples/withStagingOnly";

const RadiusDisplay: React.FC<{
  name: string;
  value: string;
  index: number;
}> = ({ name, value, index }) => {
  // Create a gradient of colors from our palette that are visible against the background
  const colors = [
    "bg-wk-aquamarine-100",
    "bg-wk-indigo-100",
    "bg-wk-dusk-100",
    "bg-wk-cambridge-green-100",
    "bg-wk-chili-crisp-red-100",
  ];
  const colorClass = colors[index % colors.length];
  const radiusName = name.replace("wk-radius-", "");

  return (
    <div className="rounded border border-wk-primary-ui bg-wk-primary-background p-4">
      <div className="wk-text-sm mb-2 font-mono text-wk-primary-text">
        {name}: {value}
      </div>
      <div
        style={{
          width: "100px",
          height: "100px",
          borderRadius: value,
        }}
        className={`mb-4 ${colorClass}`}
      />
      <div className="space-y-1">
        <div className="wk-text-sm font-medium text-wk-primary-text">
          Tailwind usage examples:
        </div>
        <ul className="wk-text-xs list-inside list-disc space-y-1 font-mono text-wk-primary-text">
          <li>rounded-wk-radius-{radiusName}</li>
          <li>rounded-t-wk-radius-{radiusName}</li>
          <li>rounded-b-wk-radius-{radiusName}</li>
        </ul>
      </div>
    </div>
  );
};

function RadiusPage() {
  return (
    <div className="min-h-screen bg-wk-primary-background">
      <Navigation />
      <DarkModeToggle />

      <main className="mx-auto max-w-7xl p-8">
        <header className="mb-12">
          <h1 className="wk-h4 mb-4 font-bold text-wk-primary-text">
            Border Radius
          </h1>
          <p className="wk-text-lg max-w-3xl text-wk-primary-text">
            Our border radius system provides consistent corner rounding across
            the application. These tokens are used to define the shape of UI
            elements, from buttons to cards and modals.
          </p>
        </header>

        <section className="mb-12">
          <h2 className="wk-h6 mb-4 font-semibold text-wk-primary-text">
            Border Radius Tokens
          </h2>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {Object.entries(radius).map(([key, value], index) => (
              <RadiusDisplay key={key} name={key} value={value} index={index} />
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

export { getServerSideProps };
export default withStagingOnly(RadiusPage);
